import { stripDocFilenameOrderPrefix } from '~/utils/docs-manifest';

/**
 * Resolve a relative/absolute .md href against folderPath (docs-relative dir) to a logical doc path.
 */
export function resolveMdHrefToLogical(hrefPath: string, folderPath: string): string | null {
  const trimmed = hrefPath.trim();
  if (!trimmed || trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('//')) {
    return null;
  }

  const base = folderPath ? `https://_/${folderPath}/` : 'https://_/';
  let pathname: string;
  try {
    pathname = new URL(trimmed, base).pathname;
  } catch {
    return null;
  }

  let p = pathname.replace(/^\/+/, '').replace(/\.md$/i, '');
  if (!p) {
    return null;
  }

  if (p.endsWith('/README')) {
    p = p.slice(0, -'/README'.length);
  }

  const parts = p.split('/').filter(Boolean);
  if (parts.length) {
    const last = parts[parts.length - 1];
    parts[parts.length - 1] = stripDocFilenameOrderPrefix(last).slug;
    p = parts.join('/');
  }

  return p || null;
}
